const ENMeetingsPanel = {
	"Assunto deve conter no máximo 200 caracteres": "Subject must contain a maximum of 200 characters",
	"Copiar pauta": "Copy agenda",
	"Painel de reuniões":"Meeting's panel",
	"Painel de Reuniões": "Meeting's Panel",
	"Nova reunião":"New Meeting",
	"Tipo de reunião":"Meeting type",
	"Todas as reuniões":"All meetings",
	"Minhas reuniões":"My meetings",
	"Assunto da reunião não confere":"Meeting's subject does not match",
	"Assunto da reunião é requerido":"Meeting's subject is required",
	"Sala de reunião é requerido":"Meeting room is required",
	"Pauta é requerida":"Agenda is required",
	"Participantes não podem ser repetidos":"Participants cannot be repeated",
	"Participantes externos não podem ser repetidos":"External participants cannot be repeated",
	"Participante é requerido":"Participant is required",
	"Participante externo é requerido":"External participant is required",
	"Erro ao buscar reuniões":"Error on search meetings",
	"Executar reunião":"Run meeting",
	"Comparecer":"Attend",
	"Finalizada(s)":"Finished",
	"Não finalizada(s)":"Not finished",
	"Não finalizada":"Not finished",
	"Assunto":"Subject",
	"Sala de reunião":"Meeting room",
	"Reunião excluída com sucesso":"Meeting successfully deleted",
	"Erro ao excluir reunião":"Error on delete meeting",
	"Exclusão de reunião":"Delete meeting",
	"Deseja realmente excluir a reunião":"Do you really want to delete the meeting",
	"Digite o assunto da reunião para excluí-la":"Enter the meeting's subject to delete it",
	"Reunião adicionada com sucesso":"Meeting successfully added",
	"Reunião alterada com sucesso":"Meeting successfully changed",
	"Erro ao adicionar reunião":"Error on add meeting",
	"Erro ao alterar reunião":"Error on change meeting",
	"Finalizar a reunião":"Finish meeting",
	"Deseja finalizar a reunião":"Do you want to finish the meeting",
	"Erro ao verificar recursos":"Error on verify resources",
	"Adicionar reunião":"Add meeting",
	"Alterar reunião":"Change meeting",
	"Copiar reunião":"Copy meeting",
	"Visualizar reunião":"View meeting",
	"Reabrir reunião":"Reopen meeting",
	"Recursos ocupados":"Ocupied resources",
	"A sala de reunião":"The meeting room",
	"está ocupada nesta data":"",
	"De acordo":"Agree",
	"Em desacordo":"Desagree",
	"Ação vinculada com sucesso":"Action successfully linked",
	"Erro ao vincular ação à reunião":"Error on link action on meeting",
	"Data da reunião":"Meeting date",
	"Hora de encerramento":"End hour",
	"Dias para finalizar":"Days to finish",
	"Pauta":"Agenda",
	"Ata":"Minutes",
	"Esteve Presente":"Was present",
	"Concorda com a ata":"Agree with the minutes of meeting",
	"Participante externo":"External Participant",
	"Adicionar participante externo":"Add external Participant",
	"Nenhum participante encontrado":"No participant found",
	"Informação do participante alterado com sucesso":"Participant info successfully changed",
	"Erro ao alterar informação do participante":"Error on change participant info",
	"Informações do participante":"Participant info",
	"Erro ao buscar detalhes da reunião":"Error on search meeting details",
	"está ocupada nos seguintes horários":"is occupied in the following times",
	"Os participantes abaixo estão ocupados nesta data":"The participants below are busy on this date"
};

export default ENMeetingsPanel;
